/* eslint-disable indent */
/* eslint-disable no-nested-ternary */
import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useDispatch } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { useSnackbar } from 'notistack'

import { checkErrorResponse, Logger, LoggerTypes } from '../../../../../utils'
import { DialogFormEdit } from '../../../../dialogs'
import { AttributeLocationForm } from '../../AttributeLocationForm'
import '../../../style-common-dialog.scss'

export const AttributeLocationDialogCreate = ({
  currentProject,
  currentScenario,
  openDialog,
  setOpenDialog,
  actionCreateDispatch
}) => {
  const [errors, setErrors] = useState(null)

  const dispatch = useDispatch()
  const { enqueueSnackbar } = useSnackbar()
  const { t } = useTranslation()

  const title = currentScenario
    ? t('attributes.locations.create.scenario')
    : currentProject
    ? t('attributes.locations.create.project')
    : t('attributes.locations.create.global')

  /**
   * Action received from the Location Form.
   * @see AttributeLocationForm
   *
   * @param {object} newLocation New location object to create.
   * @param {string} newLocationId here it's null.
   * @param {func} onSuccess Function to execute on success.
   */
  const onDispatchAction = (newLocation, newLocationId, onSuccess) => {
    Logger.trace(LoggerTypes.CONTROLLER, 'AttributeLocationDialogCreate.onDispatchAction()', {
      newLocation,
      newLocationId
    })

    dispatch(actionCreateDispatch(newLocation, currentProject?.id, currentScenario?.id))
      .then((res) => {
        Logger.trace(
          LoggerTypes.CONTROLLER,
          'AttributeLocationDialogCreate.onDispatchAction().dispatch(actionCreateDispatch()).then()',
          {
            res
          }
        )

        if (onSuccess && typeof onSuccess === 'function') {
          onSuccess(res)
        }
      })
      .catch((res) => {
        Logger.trace(
          LoggerTypes.WARN,
          'AttributeLocationDialogCreate.onDispatchAction().dispatch(actionCreateDispatch()).catch()',
          {
            res
          }
        )

        checkErrorResponse(res, enqueueSnackbar, t)

        if (res?.response?.data?.fields) {
          setErrors(res.response.data.fields)
        }
      })
  }

  Logger.trace(LoggerTypes.CONTAINER, 'AttributeLocationDialogCreate.render()')

  return (
    <DialogFormEdit className="attribute-form" openDialog={openDialog} setOpenDialog={setOpenDialog}>
      <AttributeLocationForm
        title={title}
        setOpenDialog={setOpenDialog}
        dispatchAction={onDispatchAction}
        errors={errors}
      />
    </DialogFormEdit>
  )
}

AttributeLocationDialogCreate.propTypes = {
  currentProject: PropTypes.object,
  currentScenario: PropTypes.object,
  openDialog: PropTypes.bool.isRequired,
  setOpenDialog: PropTypes.func.isRequired,
  actionCreateDispatch: PropTypes.func.isRequired
}

AttributeLocationDialogCreate.defaultProps = {
  currentProject: null,
  currentScenario: null,
  openDialog: false,
  setOpenDialog: () => {},
  actionCreateDispatch: () => {}
}
